<template>
  <PricesVertical
    :is-loading="isLoading"
    :title="title"
    :period="period"
    :button-text="buttonText"
    :button-text-free-trial="buttonTextFreeTrial"
    :see-more="seeMore"
    :see-less="seeLess"
    :price-description="priceDescription"
    :price-description-alt="priceDescriptionAlt"
    :primary-color="primaryColor"
    :secondary-color="secondaryColor"
    :terciary-color="terciaryColor"
    :background-image="backgroundImage"
    :prices="prices"
    @subscribe="({ price }) => $emit('subscribe', { price })"
  >
    <template #switcher>
      <Switcher
        style="--secondary-color: white"
        :left-image="leftSwitchImage"
        :left-text="leftSwitchText"
        :right-image="rightSwitchImage"
        :right-text="rightSwitchText"
        :switch-on-annual="showSecondPlanArea"
        @switch="(isRight) => (showSecondPlanArea = isRight)"
      />
    </template>
  </PricesVertical>
</template>
<script>
export default {
  components: {
    PricesVertical: () => import('@/components/Prices/PricesVertical'),
    Switcher: () => import('@/components/Prices/PricesVerticalWithSwitch/Switcher')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    terciaryColor: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    leftSwitchImage: {
      type: Object,
      required: true,
      validator: (leftImage) => 'url' in leftImage
    },
    leftSwitchText: {
      type: String,
      required: true
    },
    rightSwitchImage: {
      type: Object,
      required: true,
      validator: (rightImage) => 'url' in rightImage
    },
    rightSwitchText: {
      type: String,
      required: true
    },
    firstPlanAreaPrices: {
      type: Array,
      required: true
    },
    secondPlanAreaPrices: {
      type: Array,
      required: true
    },
    seeMore: {
      type: String,
      required: true
    },
    seeLess: {
      type: String,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    priceDescriptionAlt: {
      type: String,
      required: true
    },
    buttonTextFreeTrial: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showSecondPlanArea: true
    };
  },
  computed: {
    prices() {
      return this.showSecondPlanArea ? this.secondPlanAreaPrices : this.firstPlanAreaPrices;
    }
  }
};
</script>
